import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { initials } from "@/lib/format";
import type { UserSummary } from "@/types/api";

interface UserAvatarProps {
  user: Pick<UserSummary, "full_name">;
  className?: string;
  fallbackClassName?: string;
}

/**
 * A person's initials in a circle. There are no profile pictures (customer,
 * 2026-10-21: removed rather than fixed), so this is the only face anyone has.
 */
export function UserAvatar({ user, className, fallbackClassName }: UserAvatarProps) {
  return (
    <Avatar className={className}>
      <AvatarFallback className={fallbackClassName}>{initials(user.full_name)}</AvatarFallback>
    </Avatar>
  );
}
